import { rootStateBranchSelector } from 'shared/utils/rootStateBranchSelector';

export const selectExperiments = rootStateBranchSelector('abUseExperiments');
